/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_Timezone_HintInputs */

const cs_settings_office_timezone_hint = /** @type {(inputs: Settings_Office_Timezone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Používá se pro topování inzerátů a firemní rozvrhy. Každý si v Profilu může nastavit vlastní zobrazení času.`)
};

const en_settings_office_timezone_hint = /** @type {(inputs: Settings_Office_Timezone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Used for portal bumps and office-wide schedules. Each person can still set their own display timezone in Profile.`)
};

/**
* | output |
* | --- |
* | "Used for portal bumps and office-wide schedules. Each person can still set their own display timezone in Profile." |
*
* @param {Settings_Office_Timezone_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_timezone_hint = /** @type {((inputs?: Settings_Office_Timezone_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_Timezone_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_timezone_hint(inputs)
	return cs_settings_office_timezone_hint(inputs)
});